import { Auth } from "../context/AuthProvider";

/**
 * Decode token to get the Auth
 * @param token string
 * @returns Auth || {}
 */
export function decodeToken(token: string): Auth {
  if (!!!token) return {} as Auth
  return JSON.parse(atob(token.split('.')[1]));
}

/**
 * To check if the token is expiring soon
 * @param token string
 * @param bufferSeconds number = 3000 (5 minutes)
 * @returns boolean
 */
export function isExpiringSoon(token: string, bufferSeconds: number = 3000) {
  if (!!!token) return true;

  const decoded = decodeToken(token);
  const expirationTime = decoded.exp;
  const currentTimeInSeconds = new Date().getTime() / 1000; // in seconds
  return expirationTime - currentTimeInSeconds < bufferSeconds;
};